export enum EventsTableColumnId {
  Checkbox = 'checkbox',
  Event = 'event',
  Venue = 'venue',
  Location = 'location',
  Date = 'date',
  TotalQty = 'totalQty',
  SoldQty = 'soldQty',
  ActualSTR = 'actualSTR',
  Revenue = 'revenue',
  SoldCost = 'soldCost',
  Profit = 'profit',
  LiftPercentage = 'liftpercentage',
  ATP = 'atp',
  ListedQty = 'listedQty',
  ListedAtp = 'listedAtp',
  UnsoldQty = 'unsoldQty',
  BoostRemainingBudget = 'boostRemainingBudget',
  Action = 'action',
  UnsoldProceeds = 'unsoldProceeds',
  UnsoldCost = 'unsoldCost',
  TotalCost = 'totalCost',
  LastPriceUpdatedDate = 'lastPriceUpdatedDate',
  LastReviewedDate = 'lastReviewedDate',
  LastSaleDate = 'lastSaleDate',
  QtySoldL7 = 'qtySoldL7',
  QtySoldL3 = 'qtySoldL3',
  QtySoldL1 = 'qtySoldL1',
  UnfulfilledPercent = 'unfulfilledPercent',
  PendingSourcingQty = 'pendingSourcingQty',
}
